module.exports = {
  "zones": {
    "America/Santiago": ["z", {
      "wallclock": -713667600000,
      "format": "-04/-03",
      "abbrev": "-04",
      "offset": -14400000,
      "posix": -713649600000,
      "save": 0,
      "rules": "Chile"
    }, {
      "wallclock": -718070400000,
      "format": "-05",
      "abbrev": "-05",
      "offset": -18000000,
      "posix": -718056000000,
      "save": 0
    }, {
      "wallclock": -736387200000,
      "format": "-04",
      "abbrev": "-04",
      "offset": -14400000,
      "posix": -736376400000,
      "save": 0
    }, {
      "wallclock": -740534400000,
      "format": "-03",
      "abbrev": "-03",
      "offset": -14400000,
      "posix": -740520000000,
      "save": 3600000
    }, {
      "wallclock": -865296000000,
      "format": "-04",
      "abbrev": "-04",
      "offset": -14400000,
      "posix": -865278000000,
      "save": 0
    }, {
      "wallclock": -870566400000,
      "format": "-05",
      "abbrev": "-05",
      "offset": -18000000,
      "posix": -870552000000,
      "save": 0
    }, {
      "wallclock": -1178150400000,
      "format": "-04",
      "abbrev": "-04",
      "offset": -14400000,
      "posix": -1178132400000,
      "save": 0
    }, {
      "wallclock": -1336003200000,
      "format": "-05/-04",
      "abbrev": "-04",
      "offset": -18000000,
      "posix": -1335986234000,
      "save": 3600000,
      "rules": "Chile"
    }, {
      "wallclock": -1593820800000,
      "format": "SMT",
      "abbrev": "SMT",
      "offset": -16966000,
      "posix": -1593806400000,
      "save": 0
    }, {
      "wallclock": -1619222400000,
      "format": "-04",
      "abbrev": "-04",
      "offset": -14400000,
      "posix": -1619205434000,
      "save": 0
    }, {
      "wallclock": -1688428800000,
      "format": "SMT",
      "abbrev": "SMT",
      "offset": -16966000,
      "posix": -1688410800000,
      "save": 0
    }, {
      "wallclock": -1892678400000,
      "format": "-05",
      "abbrev": "-05",
      "offset": -18000000,
      "posix": -1892661434000,
      "save": 0
    }, {
      "wallclock": -2524521600000,
      "format": "SMT",
      "abbrev": "SMT",
      "offset": -16966000,
      "posix": -2524504634000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -16966000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Chile": [{
      "from": 2019,
      "to": 1.7976931348623157e+308,
      "month": 3,
      "day": [0, 2],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2019,
      "to": 1.7976931348623157e+308,
      "month": 8,
      "day": [0, 2],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2016,
      "to": 2018,
      "month": 4,
      "day": [0, 9],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2016,
      "to": 2018,
      "month": 7,
      "day": [0, 9],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2012,
      "to": 2014,
      "month": 3,
      "day": [0, 23],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2012,
      "to": 2014,
      "month": 8,
      "day": [0, 2],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2011,
      "to": 2011,
      "month": 4,
      "day": [0, 2],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2011,
      "to": 2011,
      "month": 7,
      "day": [0, 16],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1999,
      "to": 2010,
      "month": 9,
      "day": [0, 9],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2010,
      "to": 2010,
      "month": 3,
      "day": [0, 1],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2009,
      "to": 2009,
      "month": 2,
      "day": [0, 9],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2008,
      "to": 2008,
      "month": 2,
      "day": [7, 30],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2000,
      "to": 2007,
      "month": 2,
      "day": [0, 9],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1999,
      "to": 1999,
      "month": 3,
      "day": [7, 4],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1998,
      "to": 1998,
      "month": 2,
      "day": [0, 9],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1998,
      "to": 1998,
      "month": 8,
      "day": [7, 27],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1991,
      "to": 1997,
      "month": 9,
      "day": [0, 9],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1997,
      "to": 1997,
      "month": 2,
      "day": [7, 30],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1991,
      "to": 1996,
      "month": 2,
      "day": [0, 9],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1988,
      "to": 1990,
      "month": 2,
      "day": [0, 9],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1990,
      "to": 1990,
      "month": 8,
      "day": [7, 16],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1988,
      "to": 1989,
      "month": 9,
      "day": [0, 9],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1987,
      "month": 9,
      "day": [0, 9],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1987,
      "to": 1987,
      "month": 3,
      "day": [7, 12],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1972,
      "to": 1986,
      "month": 2,
      "day": [0, 9],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1973,
      "to": 1973,
      "month": 8,
      "day": [7, 30],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1970,
      "to": 1972,
      "month": 9,
      "day": [0, 9],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1971,
      "to": 1971,
      "month": 2,
      "day": [7, 14],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1970,
      "to": 1970,
      "month": 2,
      "day": [7, 29],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1969,
      "to": 1969,
      "month": 2,
      "day": [7, 30],
      "time": 180,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1969,
      "to": 1969,
      "month": 10,
      "day": [7, 23],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1968,
      "to": 1968,
      "month": 10,
      "day": [7, 3],
      "time": 240,
      "clock": "posix",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1928,
      "to": 1932,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1927,
      "to": 1931,
      "month": 8,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }]
  }
};